var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMetasIapps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.5 65",
    style: {
      enableBackground: "new 0 0 66.5 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E30000;}\n\t.st1{fill:#E13332;}\n\t.st2{fill:#E4F4FD;}\n\t.st3{fill:#FDFDFD;}\n\t.st4{fill:#465867;}\n\t.st5{fill:#008B81;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    className: "st0",
    d: "M30.8,7L18.7,37.6l12.1,27.2c16,0,28.9-13,28.9-28.9C59.7,19.9,46.8,7,30.8,7L30.8,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    className: "st1",
    d: "M1.9,35.9c0,16,12.9,28.9,28.9,28.9V7C14.8,7,1.9,19.9,1.9,35.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    className: "st2",
    d: "M30.8,14.6l-8.9,22.6l8.9,20c11.8,0,21.3-9.5,21.3-21.3S42.6,14.6,30.8,14.6L30.8,14.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_153",
    className: "st3",
    d: "M9.5,35.9c0,11.8,9.5,21.3,21.3,21.3l0,0V14.6C19,14.6,9.5,24.1,9.5,35.9L9.5,35.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    className: "st0",
    d: "M30.8,22.2l-5.7,14.5l5.7,12.8c7.5,0,13.7-6.1,13.7-13.7C44.5,28.3,38.3,22.2,30.8,22.2 L30.8,22.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    className: "st1",
    d: "M17.1,35.9c0,7.5,6.1,13.7,13.7,13.7V22.2C23.3,22.2,17.1,28.3,17.1,35.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_156",
    className: "st2",
    d: "M30.8,29.8l-2.5,6.4l2.5,5.7c3.3,0,6-2.7,6-6C36.8,32.5,34.1,29.9,30.8,29.8L30.8,29.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_157",
    className: "st3",
    d: "M24.8,35.9c0,3.3,2.7,6,6,6c0,0,0,0,0,0V29.8C27.5,29.8,24.8,32.5,24.8,35.9 C24.8,35.9,24.8,35.9,24.8,35.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    className: "st4",
    d: "M50.6,13.4l2.7,2.7L32.1,37.2l-2.7-2.7L50.6,13.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    className: "st5",
    d: "M58.7,0.2L47,11.9l1.5,6.3l6.3,1.5L66.5,8L60.6,6L58.7,0.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetasIapps);
export default __webpack_public_path__ + "static/media/icon-metas-iapps.191255a4f153517caedc3cc4d3a1df12.svg";
export { ForwardRef as ReactComponent };